import { themeV5 } from 'src/theme';

import { createIcon } from './icon-utils';

export const FavoriteStarIcon = createIcon({
  fill: themeV5.appColors.rule,
  path: 'M7.403 20.012c-.573.36-1.291-.163-1.127-.818l1.325-5.265-4.166-3.48c-.519-.434-.244-1.278.43-1.324l5.416-.367 2.023-5.037c.252-.628 1.14-.628 1.392 0l2.023 5.037 5.416.367c.674.046.949.89.43 1.324l-4.166 3.48 1.325 5.265c.164.655-.554 1.177-1.127.818L12 17.126l-4.597 2.886z',
});
